<script lang="ts">
	import type { LogoSliderBlock } from '$models/Block/LogoSliderBlock';
	import type { Snippet } from 'svelte';
	import { getWordPressImageSrcSet } from '$lib/images';

	type Logo = LogoSliderBlock['logos'][number];

	interface Props {
		block: LogoSliderBlock;
		renderTrack: Snippet<[Snippet<[Logo, number]>]>;
	}

	let { block, renderTrack }: Props = $props();
</script>

{#snippet renderLogo(logo: Logo, index: number)}
	<div class="logo-slider-item" data-logo-index={index}>
		{#if logo.link}
			<a class="logo-slider-link" href={logo.link.url}>
				<figure class="logo-slider-image">
					<img
						src={logo.image.url}
						srcset={getWordPressImageSrcSet(logo.image)}
						sizes="(min-width: 1024px) 14.28vw, (min-width: 768px) 16.67vw, 25vw"
						alt={logo.image.alt}
						width={logo.image.width}
						height={logo.image.height}
						loading="lazy"
						decoding="async"
					/>
				</figure>
			</a>
		{:else}
			<figure class="logo-slider-image">
				<img
					src={logo.image.url}
					srcset={getWordPressImageSrcSet(logo.image)}
					sizes="(min-width: 1024px) 14.28vw, (min-width: 768px) 16.67vw, 25vw"
					alt={logo.image.alt}
					width={logo.image.width}
					height={logo.image.height}
					loading="lazy"
					decoding="async"
				/>
			</figure>
		{/if}
	</div>
{/snippet}

{@render renderTrack(renderLogo)}

<style lang="postcss" global>
	.logo-slider {
		& {
			margin: 0 auto;
			max-width: 100%;
		}

		.slider {
			margin-left: 0;
			margin-right: 0;
			--slide-size: 50%;
			--slide-spacing: 0;

			@media (--sm) {
				--slide-size: 33.3333333333%;
			}

			@media (--md) {
				--slide-size: 25%;
			}

			@media (--lg) {
				--slide-size: 20%;
			}

			@media (--xl) {
				--slide-size: 14.2857142857%;
			}
		}

		&:not(:last-child) {
			margin-bottom: var(--spacing-10);
		}

		&-link {
			display: block;

			&:hover {
				img {
					opacity: 0.85;
				}
			}
		}

		&-image {
			width: 100%;
			height: 48px;
			display: flex;
			align-items: center;
			justify-content: center;

			@media (--xl) {
				height: 40px;
			}

			img {
				display: block;
				width: 100%;
				height: auto;
				max-width: 80%;
				max-height: 48px;
				object-fit: contain;
				object-position: center;
				filter: grayscale(100%);
				opacity: 0.5;
				transition: opacity 0.3s ease-in-out;

				@media (--sm) {
					max-width: 75%;
				}

				@media (--xl) {
					max-height: 40px;
				}
			}
		}
	}
</style>
